import { BehaviorParameters } from 'rangeConfig/@types';
import { addInteriorSuggestionToPlatsaFrame } from '../utils/interiorSuggestions';

const addPlatsaInteriorSuggestion = ({
  coreApi,
  props,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const coreProductId = props.coreProductId || props.coreProductIds[0];
  addInteriorSuggestionToPlatsaFrame(coreProductId, products, props.menu, coreApi);
};

export default addPlatsaInteriorSuggestion;
